import React from 'react';
import { Heading, Text, VStack, Container } from '@chakra-ui/react';

const PrivacyPolicy = () => (
  <Container maxW="2xl" centerContent py={12}>
    <VStack spacing={6} align="start">
      <Heading
        as="h1"
        size="lg"
        textAlign="center"
        width="100%"
        mb={10}
        mt={10}
      >
        プライバシーポリシー
      </Heading>

      <Text>
        当サービス（以下「本サービス」）は、ユーザーのプライバシーを尊重し、個人情報の保護に努めます。本プライバシーポリシーは、本サービスにおいて収集する情報の内容、利用目的、および取り扱い方針について説明するものです。
      </Text>

      <Text fontWeight="bold">1. 収集する情報</Text>
      <Text>
        本サービスでは、ユーザーから以下の情報を収集する場合があります：
        <br />
        ・メールアドレス（お問い合わせ時など）
        <br />
        ・サービス利用に関する統計情報（ブラウザ種別、アクセス日時など）
        <br />
        ・Cookie等を使用したアクセス解析情報
      </Text>

      <Text fontWeight="bold">2. 情報の利用目的</Text>
      <Text>
        収集した情報は以下の目的で利用します：
        <br />
        ・サービスの運営・改善のため
        <br />
        ・ユーザーからのお問い合わせ対応のため
        <br />
        ・不正利用の防止・セキュリティ向上のため
        <br />
        ・法令に基づく対応のため
      </Text>

      <Text fontWeight="bold">3. 情報の第三者提供について</Text>
      <Text>
        法令に基づく場合を除き、ユーザーの同意なく第三者に個人情報を提供することはありません。
      </Text>

      <Text fontWeight="bold">4. 情報の安全管理</Text>
      <Text>
        本サービスは、個人情報への不正アクセス・紛失・改ざん・漏えい等を防止するため、適切な安全対策を講じます。
      </Text>

      <Text fontWeight="bold">5. 外部サービスの利用について</Text>
      <Text>
        アクセス解析や広告配信等のために、Google
        Analytics等の外部サービスを利用する場合があります。これらのサービスはCookieを使用することがあります。
      </Text>

      <Text fontWeight="bold">6. プライバシーポリシーの変更</Text>
      <Text>
        本ポリシーの内容は、法令の変更やサービス内容の変更に応じて予告なく改定することがあります。変更後の内容は本ページにて公表します。
      </Text>

      {/* <Text fontWeight="bold">7. お問い合わせ</Text>
      <Text>
        本プライバシーポリシーに関するお問い合わせは、以下の連絡先までお願いいたします：
        <br />
        メールアドレス：example@example.com
      </Text> */}
    </VStack>
  </Container>
);

export default PrivacyPolicy;
